import Cookies from "js-cookie"
import { listCoursesAdapter } from "../../adapters/get-list-courses.adapter"
import { ACCESS_TOKEN } from "../../util/constants/APP_RESERVED_NAME"
import { API_HEADER } from "../../util/constants/HEADERS"

export async function getCoursesByGroup(group_id: string) {
    return await fetch(`${process.env.REACT_APP_API_URL}course/getListByGroup/${group_id}`, {
        method: 'GET',
        headers: {
            ...API_HEADER,                
            Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
        },
    })
    .then((response) => response.json())
    .then(async (result) => {
        if (result.status) {
            return {
                response: listCoursesAdapter(result.data)
            }
        }
    })
    .catch(err => {
        return {
            response: {
                data: []
            }
        }
    })
}

export function getCompletedCourses () {
    const user_json = JSON.parse(localStorage.getItem('asg_user') ?? '{}')

    return fetch(`${process.env.REACT_APP_API_URL}course/completedCourses/${user_json.id}`, {
        method: 'GET',
        headers: {
            ...API_HEADER,                
            Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
        },
    })
    .then(res => res.json())
    .then(res => ({
        ...res,
        data: res.data.toString().padStart(2, '0')
    }))
   
}

export function getCompletedCourseList (group_id: string) {
    const user_json = JSON.parse(localStorage.getItem('asg_user') ?? '{}')

    return fetch(`${process.env.REACT_APP_API_URL}course/byUser/${user_json.id}?group_id=${group_id}`, {
        method: 'GET',
        headers: {
            ...API_HEADER,                
            Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
        },
    })
    .then(res => res.json())
    .then(res => ({
        ...res
    }))
   
}